import { axios } from './commons';

export default {
  getConfig: () => axios.get('/system/config'),
  setConfigLiveFeedPool: (poolsConfigYaml = '') =>
    axios.post('/system/config', {
      poolsConfigYaml,
    }),
  setActiveFeed: ({ poolName, participant }) =>
    axios.put('/system/config/activate-feed', {
      poolName,
      participant,
    }),
  saveReferralTypes: (referralTypes) =>
    axios.put('/system/config/referral', {
      referralTypes,
    }),
};
